import { render, staticRenderFns } from "./SurgicalHistoryButton.vue?vue&type=template&id=555399ec&"
import script from "./SurgicalHistoryButton.vue?vue&type=script&lang=js&"
export * from "./SurgicalHistoryButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports